export const communicationStyles = {
    panel: 'overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-900',
    heading: 'font-extrabold text-slate-900 dark:text-slate-100',
    muted: 'text-sm text-slate-500 dark:text-slate-400',
    input: 'w-full rounded-xl border border-slate-300 bg-white p-3 text-sm text-slate-900 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100',
    primaryButton: 'rounded-lg bg-blue-600 px-4 py-2 text-sm font-bold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50',
    secondaryButton: 'rounded-lg border border-slate-300 px-4 py-2 text-sm font-bold text-slate-600 hover:bg-slate-100 disabled:opacity-50 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-800',
    error: 'rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700 dark:bg-red-950 dark:text-red-300',
};

export const managementCommunicationStyles = {
    heading: 'text-xl font-extrabold text-slate-900',
    muted: 'text-xs text-slate-400',
    table: 'overflow-x-auto rounded-xl border border-slate-200 bg-white shadow-sm',
    tableHead: 'border-b border-slate-200 bg-slate-50 text-xs font-semibold uppercase text-slate-500',
    tableRow: 'transition-colors hover:bg-slate-50',
    secondaryButton: 'rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-600 transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50',
    error: 'rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-700',
};
